export const formatNumberTwoDecimalPlaces = (number = 0) => number.toFixed(2).replace(/\.00$/, '');
